import { CSSObjectWithLabel } from "react-select";

export const buildCustomStyles = (isDark: boolean) => {
  const palette = {
    text: isDark ? "#ffffff" : "#000000",
    controlBg: isDark ? "hsl(222.2 84% 4.9%)" : "transparent",
    menuBg: isDark ? "hsl(222.2 84% 4.9%)" : "#ffffff",
    optionHoverBg: isDark ? "#1F2937" : "#F3F4F6",
    placeholder: isDark ? "#9CA3AF" : "#000000",
  };

  return {
    control: (base: CSSObjectWithLabel): CSSObjectWithLabel => ({
      ...base,
      borderRadius: "12px",
      border: "2px solid hsl(var(--primary))!important",
      backgroundColor: palette.controlBg,
      height: "auto",
      boxShadow: "none",
      minHeight: "34px",
      minWidth: "50px",
      cursor: "pointer",
    }),
    singleValue: (base: CSSObjectWithLabel) => ({
      ...base,
      color: palette.text,
      fontSize: "12px",
      fontWeight: "600",
    }),
    valueContainer: (base: CSSObjectWithLabel) => ({
      ...base,
      padding: "0px",
      paddingLeft: "4px",
    }),
    dropdownIndicator: (base: CSSObjectWithLabel) => ({
      ...base,
      padding: "0 6px 0 4px",
      width: "24px",
      color: palette.text,
    }),
    indicatorContainer: (base: CSSObjectWithLabel) => ({
      ...base,
      padding: "0!important",
      paddingLeft: "6px",
    }),
    indicatorSeparator: (base: CSSObjectWithLabel) => ({
      ...base,
      display: "none",
    }),
    placeholder: (base: CSSObjectWithLabel) => ({
      ...base,
      color: palette.placeholder,
      fontSize: "14px",
      fontWeight: "600",
    }),
    menu: (base: CSSObjectWithLabel) => ({
      ...base,
      minWidth: "100px",
      backgroundColor: palette.menuBg,
      color: palette.text,
      zIndex: 50,
    }),
    option: (base: CSSObjectWithLabel, state: any) => ({
      ...base,
      color: state.isSelected ? "white" : palette.text,
      fontSize: "14px",
      fontWeight: "600",
      backgroundColor: state.isSelected
        ? "hsl(var(--primary))"
        : state.isFocused
          ? palette.optionHoverBg
          : palette.menuBg,
      cursor: "pointer",
    }),
    input: (base: CSSObjectWithLabel) => ({
      ...base,
      margin: "0!important",
      color: palette.text,
    }),
  };
};

export const customStyles = buildCustomStyles(false);
